import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { RecaptchaModule } from "ng-recaptcha";
//import { RecaptchaV3Module, RECAPTCHA_V3_SITE_KEY } from 'ng-recaptcha';
//import { environment } from '../../../../environments/environment';
import { LoginComponent } from './login.component';
import { LoginRoutingModule } from './login-routing.module';
import { SpinnerModule } from '../../components/spinner/spinner.module';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { IConfig, NgxMaskModule } from 'ngx-mask';


const maskConfig: Partial<IConfig> = {
  validation: false,
};

@NgModule({
  declarations: [
    LoginComponent
  ],
  imports: [
    CommonModule,
    LoginRoutingModule,
    ReactiveFormsModule,
  //  RecaptchaV3Module,
    SpinnerModule,
    NgxSkeletonLoaderModule,
    NgxMaskModule.forRoot(maskConfig),

  ],
   exports: [
      LoginComponent
  ]
//  providers: [{ provide: RECAPTCHA_V3_SITE_KEY, useValue: environment.recaptchaKeyV3 }]
})
export class LoginModule { }
